import { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

/**
 * A titled white card with an optional row of header controls.
 *
 * The same `bg-white rounded-lg shadow p-4` + icon heading shell is written out
 * by hand across the app. This is the one place it is defined; new cards should
 * use it, and existing ones move over as they are touched rather than in one
 * sweeping change.
 */
export interface PanelCardProps {
  title: ReactNode
  icon?: IconDefinition
  /** Controls rendered at the right of the heading (toggles, pickers, links). */
  actions?: ReactNode
  className?: string
  children: ReactNode
}

export default function PanelCard({ title, icon, actions, className = '', children }: PanelCardProps) {
  return (
    <div className={`bg-white rounded-lg shadow p-4 ${className}`}>
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2">
          {icon && <FontAwesomeIcon icon={icon} className="text-gray-400" />}
          {title}
        </h3>
        {actions && <div className="flex items-center gap-3">{actions}</div>}
      </div>
      {children}
    </div>
  )
}
